var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('section',[_c('div',{staticClass:"default-background header"},[_vm._m(0),_c('collection-overview')],1)])
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"padding-20"},[_c('span',{staticClass:"header-title"},[_c('span',{staticClass:"header-mark"}),_vm._v("调解总览")])])
}]

export { render, staticRenderFns }